import { useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { http, formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const BookingAccessForm = ({ mode = "lookup", initialCode = "", onSuccess, onStart }) => {
  const { t } = useLang();
  const { authenticate, refreshUser, user } = useAuth();
  const [form, setForm] = useState({ code: initialCode, phone: mode === "link" ? user?.phone || "" : "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError(""); onStart?.();
    try {
      let result;
      if (mode === "login") result = { user: await authenticate("whatsapp", form) };
      else {
        result = (await http.post(`/bookings/${mode}`, form)).data;
        if (mode === "link") await refreshUser();
      }
      onSuccess(result);
    } catch (err) {
      setError(err.response?.data?.detail === "Unable to verify booking details" ? t(mode === "lookup" ? "access_lookup_error" : "access_error") : formatErr(err));
    } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} data-testid={`booking-access-${mode}-form`} className="space-y-4">
      {mode !== "lookup" && <p data-testid={`access-${mode}-proof-hint`} className="text-sm leading-relaxed text-slate-600">{t("access_proof_hint")}</p>}
      <div><Label htmlFor={`access-${mode}-code`}>{t("booking_code")}</Label><Input id={`access-${mode}-code`} data-testid={`access-${mode}-code`} autoComplete="off" autoCapitalize="characters" spellCheck={false} maxLength={40} placeholder="PTG-…" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} required className="mt-1 h-12 rounded-xl font-mono" /></div>
      <div><Label htmlFor={`access-${mode}-phone`}>{t("phone")}</Label><Input id={`access-${mode}-phone`} data-testid={`access-${mode}-phone`} type="tel" inputMode="tel" autoComplete="tel" maxLength={40} placeholder="+62… / +31…" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} required className="mt-1 h-12 rounded-xl" /><p data-testid={`access-${mode}-phone-hint`} className="mt-1.5 text-xs leading-relaxed text-slate-500">{t("access_phone_hint")}</p></div>
      {error && <p role="alert" data-testid={`access-${mode}-error`} className="rounded-xl bg-rose-50 p-3 text-sm text-rose-700">{error}</p>}
      <button data-testid={`access-${mode}-submit`} disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-full bg-[#064E3B] px-5 py-3.5 text-sm font-bold text-white transition-colors hover:bg-[#047857] disabled:opacity-60">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />}{t(mode === "lookup" ? "access_check" : `access_${mode}`)}</button>
      {mode !== "lookup" && <p data-testid={`access-${mode}-secret-hint`} className="text-xs leading-relaxed text-amber-800">{t("access_secret")}</p>}
    </form>
  );
};
